/**
 *
 * @param {string} str
 * @returns {string}
 */
export function stringReverse(str) {
  return str.split("").reverse().join("");
}
